import { matchPath } from 'react-router-dom';

export const APP_DOCUMENT_TITLE = 'OneView 4PL';

/** Minimal shape shared with `usePageAccess` page links. */
export type PageTitleSource = {
  to: string;
  label: string;
  subRoutes?: PageTitleSource[];
};

const flattenPages = (pages: PageTitleSource[]): PageTitleSource[] =>
  pages.flatMap(({ subRoutes, ...page }) => [
    page,
    ...(subRoutes ? flattenPages(subRoutes) : []),
  ]);

/**
 * Resolve a document title from `usePageAccess()` menu labels.
 * Longer paths win; list routes also cover nested detail URLs (e.g. `/templates/:id`).
 */
export const getPageTitle = (
  pathname: string,
  pages: PageTitleSource[],
): string => {
  const routes = flattenPages(pages)
    .filter((page) => page.to.startsWith('/'))
    .sort((a, b) => b.to.length - a.to.length);

  for (const { to, label } of routes) {
    const exactMatch = matchPath({ path: to, end: true }, pathname);
    const nestedMatch = matchPath({ path: `${to}/*`, end: true }, pathname);

    if (exactMatch || nestedMatch) {
      return label;
    }
  }

  return APP_DOCUMENT_TITLE;
};
